import React from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'

const RawHTML = ({ data }: any) => {
  const loadedHTML: string = data?.componentHtml?.componentHtml
  const css: string = data?.componentCss?.componentCss
  const js: string = data?.componentJs?.componentJs
  const RawHTMLWrapper = styled.section`
    ${css}
  `

  return (
    <RawHTMLWrapper data-cy="RawHTML">
      {js && (
        <Helmet>
          <script>{js}</script>
        </Helmet>
      )}
      <div
        dangerouslySetInnerHTML={{
          __html: loadedHTML,
        }}
      />
    </RawHTMLWrapper>
  )
}

export default RawHTML
